const isDev = process.env.NODE_ENV !== 'production';

const safeError = (error) => ({
  status: error?.response?.status || null,
  message: error?.message || 'Request failed',
});

export const logError = (scope, error) => {
  if (!isDev) return;
  console.error(scope, safeError(error));
};

export const logWarn = (scope, message) => {
  if (!isDev) return;
  console.warn(scope, message);
};

export const logDebug = (scope, ...args) => {
  if (!isDev) return;
  console.debug(scope, ...args);
};

export const logInfo = (scope, ...args) => {
  if (!isDev) return;
  console.log(scope, ...args);
};
